import { PlaceLanguagesType } from '../../types/languages';

import { LocaleProviderAction } from './types';

const localeProviderReducer = (
	state: PlaceLanguagesType,
	action: LocaleProviderAction
): PlaceLanguagesType => {
	switch (action.type) {
		case 'set-current-language':
			return { ...state, current: action.language };
		case 'set-language-content': {
			return { ...state, content: action.content };
		}
	}
	return state;
};

export default localeProviderReducer;
